module.exports = __webpack_public_path__ + "static/media/conveyor.0e608d98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/conveyor.svg
// module id = 648
// module chunks = 0